import {
  FEDERATED_SEARCH_ANALYTICS_OUTCOMES,
  type FederatedSearchAnalyticsOutcome,
} from '~/utils/searchEngineHelpers'

export const FEDERATED_SEARCH_ANALYTICS_SESSION_KEY =
  'konfetti-federated-search-analytics-outcome'

const isFederatedSearchAnalyticsOutcome = (
  value: string
): value is FederatedSearchAnalyticsOutcome =>
  FEDERATED_SEARCH_ANALYTICS_OUTCOMES.includes(
    value as FederatedSearchAnalyticsOutcome
  )

export const setFederatedSearchAnalyticsOutcome = (
  outcome: FederatedSearchAnalyticsOutcome
) => {
  if (typeof sessionStorage === 'undefined') {
    return
  }

  sessionStorage.setItem(FEDERATED_SEARCH_ANALYTICS_SESSION_KEY, outcome)
}

/** Read and clear the pending federated outcome (one landing page per navigation). */
export const consumeFederatedSearchAnalyticsOutcome =
  (): FederatedSearchAnalyticsOutcome | null => {
    if (typeof sessionStorage === 'undefined') {
      return null
    }

    const value = sessionStorage.getItem(FEDERATED_SEARCH_ANALYTICS_SESSION_KEY)
    sessionStorage.removeItem(FEDERATED_SEARCH_ANALYTICS_SESSION_KEY)

    if (!value || !isFederatedSearchAnalyticsOutcome(value)) {
      return null
    }

    return value
  }
